import { IonRouterOutlet, IonHeader, IonToolbar, IonTitle, IonRedirect, IonRouterLink } from '@ionic/react';
import React, { useState, useContext, useEffect } from 'react';
import { Link, Router, Redirect, Route, Switch } from "react-router-dom";


import { RouteComponentProps } from 'react-router';

import { Plugins } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences'


import { Auth_MerchantID_context }  from '../../../storeState/auth_merchantID_context'

import { useHistory} from "react-router-dom";

const { Storage } = Plugins;



async function removeStorageCredentials() {


    await Preferences.remove({ key: 'accountID' });
    await Preferences.remove({ key: 'company_phoneNumber' });
    await Preferences.remove({ key: 'employeeID' });
    await Preferences.remove({ key: 'employee_first_name' });
    await Preferences.remove({ key: 'employee_last_name' });
    await Preferences.remove({ key: 'employee_company' });
    await Preferences.remove({ key: 'employee_createdBy' });
    await Preferences.remove({ key: 'schemaName' });
    await Preferences.remove({ key: 'isAuthenticated' });
    await Preferences.remove({ key: 'accessRights' });
    await Preferences.remove({ key: 'loginUsername_authenticated' });
    await Preferences.remove({ key: 'loginPassword_authenticated' });
    await Preferences.remove({ key: 'isBiometricFingerprintAvilable' });
    await Preferences.remove({ key: 'biometricFingerprint' });
    await Preferences.remove({ key: 'device' });
    await Preferences.remove({ key: 'sessionID' });
    await Preferences.remove({ key: 'baseURL' });
    await Preferences.remove({ key: 'capability' });
    await Preferences.remove({ key: 'feature' });
    await Preferences.remove({ key: 'cartList' });
    await Preferences.remove({ key: 'fcm_token' });
    await Preferences.remove({ key: 'latitude_current' });
    await Preferences.remove({ key: 'longitude_current' });
    await Preferences.remove({ key: 'chatID_list' });
    await Preferences.remove({ key: 'websocket' });
}

export function ConfirmMerchantLogout (props){

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID] = useState(props.data.acctID);
    const [schema, setSchemaName] = useState(props.data.schema);
    let [sessionID, setSessionID ] = useState(props.data.sessionID);
    let [baseURL, setBaseURL ] = useState(props.data.baseURL);


    let [logoutSuccess, setLogoutSuccess] = useState(false);


    let history = useHistory();

    useEffect(() => { 


        // alert("In Logout use effect");
        // alert(baseURL);
        // alert(acctID);
        // alert(schema);
        // alert(sessionID);

        const requestOptions = {
            method:'POST',
            credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
            },
            //body: JSON.stringify({formData})
            body: JSON.stringify({
                user: acctID,
                schema: schema,
                sessionID: sessionID,

            })
        }

        fetch(baseURL+'merchantAcct_argsjqApp_logout', requestOptions)
        .then(res => res.text())
        .then(data => {

            // alert(data);
            // alert(props.data.source);

            if(data == '1')
            {
                if(props.data.source != 'switch_accounts')
                {
                    alert('LOG OUT SUCCESSFULL');

                removeStorageCredentials();
                //setLogoutSuccess(true);

                //alert('LOG OUT SUCCESSFULL 1');
                history.push('/');
                window.location.href = '/';
                window.location.reload();

                // authenticatedMerchent_context.changeAccountID(null);
                // authenticatedMerchent_context.companyPhoneNumber(null);
                // authenticatedMerchent_context.changeEmployeeID(null);
                // authenticatedMerchent_context.changeSchema(null);
                // authenticatedMerchent_context.changeEmployeeCreatedBy(null);
                // authenticatedMerchent_context.changeAccessRights([null, null, null, null, null]);
                // authenticatedMerchent_context.changeCookieID(null);
                // authenticatedMerchent_context.changeAuthenticated(null);
                // authenticatedMerchent_context.changeLoginUsername(null);
                // authenticatedMerchent_context.changeLoginPassword(null);
                // alert('LOG OUT SUCCESSFULL 1a');

                // authenticatedMerchent_context.changeIsBiometric_fingerprintAvilable(false);
                // authenticatedMerchent_context.changeBiometric_fingerprint(false);
                // authenticatedMerchent_context.changeDevice('desktop');
                // alert('LOG OUT SUCCESSFULL1b');

                // authenticatedMerchent_context.changeStartDateRange(new Date());
                // authenticatedMerchent_context.changeEndDateRange(new Date());
                // authenticatedMerchent_context.changeNumOfNights(null);
                // authenticatedMerchent_context.cartList([]);

            


                //     //setTimeout(() => {
                //         history.push('/');
                //         // OR
                //         window.location.href = '/';
                //         window.location.reload();
                //     //}, 200);   // 200ms should be enough for state propagation

                    //alert('LOG OUT SUCCESSFUL 2');

                }
                else
                {
                    //alert("inside props.onSwitchAccounts_loggedOut");
                    props.onSwitchAccounts_loggedOut();
                }
                //return;
            }
            else
            {

                //alert('LOG OUT - NOT - SUCCESSFULL');
                removeStorageCredentials();
                authenticatedMerchent_context.changeAuthenticated(null);
                //setLogoutSuccess(true);
                history.push('/');
                //window.location.reload(); 
                window.location.href = '/';

                //return;

            }

        })
        .catch(error => {
            console.error(error);
        })

    }, [])

    // alert('In Logout');
    // alert(authenticatedMerchent_context.authenticated);


        return(
                <React.Fragment>
                    {/*{ logoutSuccess &&  <Redirect to='/' /> }
                    {/* !logoutSuccess &&  <Redirect to='/' /> */}
                </React.Fragment>
            )  
}
    

export default ConfirmMerchantLogout;